<app-header-inner></app-header-inner>
 <!-- Subheader Start -->
 <div class="subheader dark-overlay dark-overlay-2" style="background-image: url('assets/img/subheader.jpg')">
    <div class="container">
      <div class="subheader-inner">
        <h1>Menu v2</h1>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Menu</a></li>
            <li class="breadcrumb-item active" aria-current="page">Menu v2</li>
          </ol>
        </nav>
      </div>

    </div>
  </div>
  <!-- Subheader End -->

  <!-- Menu Wrapper Start -->
  <div class="section section-padding menu-v2">
    <div class="container">

      <!-- Category Start -->
      <div class="menu-category dark-overlay dark-overlay-2" style="background-image: url('assets/img/categories-lg/1.jpg')">
        <h3>Pizzas</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard</p>
      </div>
      <div class="row">

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/1.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Pepperoni</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/2.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Four Cheese</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/3.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Barbeque Chicken</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/4.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Vegetarian</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/5.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Swiss Mushroom</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/7.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Hawaiian</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

      </div>
      <!-- Category End -->

      <!-- Category Start -->
      <div class="menu-category dark-overlay dark-overlay-2" style="background-image: url('assets/img/categories-lg/2.jpg')">
        <h3>Sides</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard</p>
      </div>
      <div class="row">

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/14.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Chicken Wrap</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">8.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/15.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Ceaser Salad</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">7.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/11.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Sea Food Noodles</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

      </div>
      <!-- Category End -->

      <!-- Category Start -->
      <div class="menu-category dark-overlay dark-overlay-2" style="background-image: url('assets/img/categories-lg/3.jpg')">
        <h3>Beverages</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard</p>
      </div>
      <div class="row">

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/9.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Orange Juice</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              </div>
              <div class="product-controls">
                <p class="product-price">4.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/13.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Rum With Soda</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              </div>
              <div class="product-controls">
                <p class="product-price">5.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/10.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Russian Beer</a> </h4>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              </div>
              <div class="product-controls">
                <p class="product-price">4.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

      </div>
      <!-- Category End -->

    </div>
  </div>
  <!-- Menu Wrapper End -->
<app-footer></app-footer>